import BaseMap from 'components/BaseMap/BaseMap';
import { DEFAULT_LOCATION_COORDS } from 'config/defaultLocation.config';
import { IoMapOutline } from 'react-icons/io5';

/** Show the selected map style at the same example location in either appearance. */
const MapPreview = ({ mapOptions }) => (
  <div className="w-100">
    <p className="user-menu-subheading d-flex align-items-center gap-2">
      <IoMapOutline aria-hidden="true" />
      Map Preview
    </p>
    <div className="accessibility-map-preview user-menu-place-map">
      <BaseMap
        key={mapOptions.mapStyle}
        mapCenter={DEFAULT_LOCATION_COORDS}
        zoom={11}
        minZoom={3}
        maxZoom={18}
        scrollZoom={false}
        disableMapControls
        disableMapReset
        mapOptions={mapOptions}
      />
    </div>
  </div>
);

export default MapPreview;
